module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "id": "rint",
      "title": "Introduction"
    }
  }, [_c('p', {
    staticClass: "fmh1"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253041401_Contents#int"
    }
  }, [_c('b', [_vm._v("INTRODUCTION")])])])]), _vm._v(" "), _c('p', {
    staticClass: "fmh2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253041401_Contents#int"
    }
  }, [_vm._v("L. Gordon McLester III and Matthew P. Payne")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEIDA")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATION OF")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDIANS OF")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISCONSIN")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEARLY")]), _vm._v(" eighteen thousand strong, was one of the original five nations of the Iroquois League that the Europeans first encountered in the sixteenth century. At one time, the Oneidas occupied a vast area of 5–6 million acres in what is now central New York. Today, the Oneidas are a federally recognized American Indian nation that has treaty rights with the US government dating back to 1784."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])]), _vm._v(" Its present reservation is composed of 25,329 acres—14,481 acres of tribal trust lands and 11,048 acres of tribal fee lands—in the environs of Green Bay situated in Brown and Outagamie counties, Wisconsin."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" Besides the Oneida Nation of Indians of Wisconsin, there are three other Oneida reservation communities: in central New York; at Southwold, Ontario; and at the Six Nations Reserve at Ohsweken, Ontario, although the latter’s connection to the other territories was largely severed because of its alliance to the British in the American Revolution. Moreover, there is also a sizeable urban Oneida community in Milwaukee, sometimes referred to as “the other Oneida.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Oneidas are a highly resilient people who have skillfully adapted to changing circumstances and made new alliances throughout their history. In the colonial era, faced with epidemics such as smallpox, measles, and influenza as well as increasing battlefield losses, they adopted numerous Iroquoian, Algonquian, and Siouan peoples into their nation and made alliances at different times in the seventeenth and eighteenth centuries with three European empires: the Dutch, the French, and the English.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The story of the Oneida–Episcopal connection has lasted for over three hundred years! When the North American continent experienced the incursion of the Europeans, the Oneidas needed to make solid relationships to support peace and stability and preserve trade. In order to ensure their survival, the Hodinöhsö:ni´, the Iroquois Confederacy of five and later six nations, through an elaborate ritual of forest diplomacy, made a series of alliances and treaties known as the Covenant Chain, reflecting three ideals: peace, friendship, and mutual respect. The parties to this Covenant Chain connection were considered to be similar to an extended family. These early alliances dissolved by the end of the colonial era and were replaced by treaty making with the newly formed US government. Subsequently, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_2",
      "title": "2"
    }
  }, [_vm._v("the metaphor of the Covenant Chain was employed to describe nongovernmental links. As early as 1811, the metaphor was used by John Henry Hobart, the third Protestant Episcopal bishop of New York, to link the church to the Indians."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")])]), _vm._v(" Later, in the 1830s, the metaphor was used by Chief Daniel Bread, along with several other chiefs, to link the church to the Oneidas."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The exact beginning of the Oneida–Episcopal connection is unknown. A year after the founding of the Society for the Propagation of the Gospel in Foreign Parts in 1701, an Anglican missionary priest reported to his church superiors that Native peoples had expressed a desire to form a relationship. The sachems of the Five Nations requested that the English monarch King William III “send them some to teach them Religion and establish traffic amongst them.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" Over the next half a century, the Anglicans or Church of England (an ancestor of the Episcopal Church) introduced the Mohawks and Oneidas to their liturgical practices. However, unlike the ideal symbolized by the Covenant Chain, it was largely a one-way street, since the church’s purpose was to Christianize so-called heathen peoples."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Following the American Revolution, the Anglican Church, largely in disrepute due to its association with loyalism to the British cause during the war, had to transform itself. It did so by recasting Anglicanism into what became the Protestant Episcopal Church in the United States. The Oneidas, who allied themselves with the Patriot cause, suffered immensely during and after the war. As soon as the conflict ended, these American Indians faced intense pressures aimed to dispossess them from their central New York homeland."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" With both the church and the Oneidas in crisis, a chain was again forged. At the 1811 ceremony, the oldest Oneida chief clasped the hand of Bishop Hobart in a formal ceremony renewing the covenant they had made at the beginning of the eighteenth century."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" The energy to reconnect the links of the chain came from the Oneidas, who were once again in need of allies. By 1816, the bishop established a mission at Oneida, the first of its kind within the Episcopal Church. However, within the next two decades, the chain became rusty, caused in part by the nefarious actions of Eleazer Williams, lay catechist and later deacon assigned by Hobart to care for the spiritual needs of the Oneidas. Despite his success as a charismatic preacher in converting Oneidas, Williams nearly severed the chain by ignoring the Oneidas’ best interests and collaborating with land speculators and government agents for his own self-aggrandizement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a result of the leadership of Bishop Jackson Kemper and Chief Daniel Bread, the missing links in the chain were restored in the late 1830s. There was a shine on the chain when the Oneida mission built the first consecrated Episcopal Church building in Wisconsin at Oneida, hosted the first ordinations to the priesthood at Oneida, and became a founding congregation of a new diocese. It glittered when "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_3",
      "title": "3"
    }
  }, [_vm._v("Chief Bread was given the seat of honor next to Bishop Jackson Kemper at the diocesan council and addressed a session in the Oneida language."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Despite the extraordinary compassion and work of Bishop Kemper, missionaries and the dominant American culture had an inherent bias. Yes, there was friendship, peace, and common religious beliefs, but that did not mean equality in the Episcopal clergy’s relationship with Native Americans. Clergy members assumed that they had the right to “civilize” Native peoples without recognizing the worth of these communities. This mental block prevented the true spirit of the Covenant Chain ideal—namely, that of two equal parties coming together in alliance and mutual respect. This myopia was often reflected in the writings of members of clergy. In 1877, John Henry Hobart Brown, the first bishop of the diocese of Fond du Lac, noted after a visit to Oneida: “The general result of my observations and inquiries is the opinion that the Church has not wasted love and money on the Oneidas, but that there has been steady, sure growth among them, of all the elements of Christian character and civilization.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" Several decades later, Julia Keen Bloomfield, in her classic book "), _c('i', [_vm._v("The Oneidas")]), _vm._v(", commented that the Sisters of the Holy Nativity would “labor for the advancement of the tribe in everything that helps towards civilization.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since the Indian New Deal of the 1930s, the Oneida Nation of Indians of Wisconsin, with its checkerboard land patterns created after the Dawes General Allotment Act of 1887, has attempted to reacquire reservation land for tribal ownership. In 1933, the Wisconsin Oneidas had fewer than ninety acres of tribally owned lands and approximately seven hundred acres of individually owned allotments."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" After World War II, the link between church and Indian community was strengthened, especially when the bishops of the diocese of Fond du Lac began to realize that a new approach was necessary to once again strengthen the chain between the church and one of its historically important parishes. From the late 1940s onward, the Wisconsin Oneidas requested that some portion of Episcopal mission property be transferred to their control because of tribal needs for housing development, athletic fields, and community meeting space. Each time, the congregation and the diocese readily agreed to the transfer, even noting in the process that they were returning the land to its original owners. In 1948, the diocese of Fond du Lac provided ten acres of its Church of the Holy Apostles’ lands for Oneida recreational purposes. Two decades later, the diocese awarded five acres to the Oneidas for athletic fields. In 1997, the diocese reached an agreement with Wisconsin Oneida and transferred two acres and the historic Bishop Grafton Parish Hall, which has served the mission since 1906; in return, the Oneidas made a formal commitment to restore the building. A decade and a half later, the diocese of Fond du Lac transferred land to the Wisconsin Oneidas to allow the development of a recreational trail connecting two shores of Duck Creek for biking and jogging."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_4",
      "title": "4"
    }
  }, [_vm._v("The diocese has supported the Oneidas in several major jurisdictional battles with their white neighbors. When a local municipality attempted to tax cemetery land three times starting in the 1950s and continuing to 2010, the diocese worked with the Oneidas to successfully resist these efforts. When the town of Hobart, carved out of Oneida treaty lands after the Dawes Act, took the position that Congress disestablished the Oneida reservation by the passage of allotment legislation from 1887 to 1910, the Episcopal Church gave clear support to the Oneidas’ position that the original treaty boundaries of 1838 still existed and that all their federal trust lands contained there were not subject to outside local regulations and taxation. The Oneida position was later upheld by the courts."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/text/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The connecting links have been strengthened in other ways. Four Wisconsin Oneidas have been ordained as full-fledged priests and deacons within the Episcopal Church, including three who have served at the Church of the Holy Apostles in the last thirty years. In 2011, Rt. Rev. Katherine Jefferts Schori, presiding bishop of the national Episcopal Church, visited the Church of the Holy Apostles and renewed the bond between the church and the Oneidas. Three years later, a conference celebrating the 175th anniversary of Bishop Kemper’s consecration of the Episcopal Church was held on the Wisconsin Oneida reservation, at which time Matthew Gunter, bishop of Fond du Lac, paid tribute to the Oneidas. In 2016, the Tri-County History Conference, sponsored by the diocese of Fond du Lac, focused on the Episcopal Church’s historic relationship with Native American communities and was held at the Oneidas’ Radisson Hotel in cooperation with the Oneida Nation of Indians of Wisconsin. Church historians and clergy from all over Canada and the United States attended. Mass was performed at the Church of the Holy Apostles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("The Wisconsin Oneidas and the Episcopal Church")]), _vm._v(": "), _c('i', [_vm._v("A Chain That Links Two Traditions")]), _vm._v(" clearly shows that good works by individuals and faith in the Creator/God by both Oneidas and Episcopal clergy were more important than esoteric aspects of theology. The two authors of this essay, one an Oneida community historian and the other a non-Indian archivist working for the diocese of Fond du Lac, share a common faith. Their working relationship is based on honesty and mutual respect, and they know that the spirit of God/Creator links them together. Both understand that human beings are not perfect and that there is always a need for self-reflection and reform to retain their friendship. Although they are different people from different cultures, they are, nevertheless, connected. That is the true meaning of the Covenant Chain as they see it.")]), _vm._v(" "), _c('p', {
    staticClass: "noteh"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". The federal treaty with the Six Nations at Fort Stanwix, 7 "), _c('i', [_vm._v("Stat")]), _vm._v("., 15 (October 22, 1784).")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". Statistics about the Oneidas’ present land base was provided by the Wisconsin Land Management Office, Oneida Nation of Indians of Wisconsin, February 17, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_5",
      "title": "5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". John Henry Hobart, "), _c('i', [_vm._v("The Correspondence of John Henry Hobart")]), _vm._v(" (New York: privately printed, 1911), cxliii.")])]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". See chapter 4 of this book.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". C. F. Pascoe, "), _c('i', [_vm._v("Two Hundred Years of the Society of the Propagation of the Gospel")]), _vm._v(" [SPG]: "), _c('i', [_vm._v("An Historical Account of the Society for the Propagation of the Gospel in Foreign Parts, 1701–1900. (Based on a digest of the Society’s records)")]), _vm._v(" (London: SPG, 1901), 73.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Laura M. Stevens, "), _c('i', [_vm._v("The Poor Indians: British Missionaries, Native Americans, and Colonial Sensibility")]), _vm._v(" (Philadelphia: University of Pennsylvania Press, 2010), 111; Daniel O’Connor, "), _c('i', [_vm._v("Three Centuries of Mission: The United Society for the Propagation of the Gospel, 1701–2000")]), _vm._v(" (London: Continuum, 2000), 34.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". For the crisis that led to the transformation of the church, see Jennifer Clark, “‘Church of Our Fathers’: The Development of the Protestant Episcopal Church Within the Changing Post-Revolutionary Anglo-American Relationship,” "), _c('i', [_vm._v("Journal of Religious History")]), _vm._v(" 18, no. 1 (1994): 27–51; David L. Holmes, “The Episcopal Church and the American Revolution,” "), _c('i', [_vm._v("Historical Magazine of the Protestant Episcopal Church")]), _vm._v(" 79 (1978): 261–91. For the Oneidas in the American Revolution, see Joseph T. Glatthaar and James Kirby Martin, "), _c('i', [_vm._v("Forgotten Allies: The Oneida Indians and the American Revolution")]), _vm._v(" (New York: Hill and Wang, 2006). For the impact of the war on the Oneidas, see Karim M. Tiro, "), _c('i', [_vm._v("The People of the Standing Stone: The Oneida Nation from the Revolution Through the Era of Removal")]), _vm._v(" (Amherst: University of Massachusetts Press, 2011), 65–192; and Laurence M. Hauptman, "), _c('i', [_vm._v("Conspiracy of Interests: Iroquois Dispossession and the Rise of New York State")]), _vm._v(" (Syracuse, NY: Syracuse University Press, 1999), 1–97.")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". Hobart, "), _c('i', [_vm._v("The Correspondence of John Henry Hobart")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "note1",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "href": "#/text/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". Harold Ezra Wagner, "), _c('i', [_vm._v("The Episcopal Church in Wisconsin, 1847–1947: A History of the Diocese of Milwaukee")]), _vm._v(" (Milwaukee, WI: Diocese of Milwaukee, 1947), 54. See also Breck’s and Kip’s excerpts in chapter 5 for two other descriptions of this convocation.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn10"
    }
  }, [_vm._v("10")]), _vm._v(". John Henry Hobart Brown, “The Oneida Indians,” "), _c('i', [_vm._v("The Church Magazine")]), _vm._v(" (April 1877), 4.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn11"
    }
  }, [_vm._v("11")]), _vm._v(". Julia K. Bloomfield, "), _c('i', [_vm._v("The Oneidas")]), _vm._v(" (New York: Alden Brothers, 1907), 343.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn12"
    }
  }, [_vm._v("12")]), _vm._v(". Jack Campisi states that there were only 84.8 acres of Oneida lands held in common, while anthropologist Harry S. Basehart states that there were 733 acres held by individual Oneidas in fee simple by the New Deal. Jack Campisi, “Ethnic Identity and Boundary Maintenance in Three Oneida Communities” (PhD diss., State University of New York, Albany, 1974), 158; Harry S. Basehart, “Historical Changes in the Kinship System of the Oneida Indians” (PhD diss., Harvard University, 1952), 218.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn13"
    }
  }, [_vm._v("13")]), _vm._v(". Numerous discussions about returning land to the Oneidas can be found in various committee minutes, 1948–2016. Archives of the Diocese of Fond du Lac, Appleton, Wisconsin.")]), _vm._v(" "), _c('p', {
    staticClass: "note",
    attrs: {
      "id": "rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/#fn14"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('i', [_vm._v("Oneida Nation of Indians of Wisconsin v. Town of Hobart")]), _vm._v(", 2013WL5692337 (7th Cir. Oct.18, 2013)."), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_6",
      "title": "6"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cbbd9dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253041401_Introduction.vue
// module id = 93
// module chunks = 0